import {Component} from '@angular/core';

@Component({
	selector: 'planthunter-amountofnewhunts-wrapper-component',
    template: `<planthunter-amountofnewhunts-component></planthunter-amountofnewhunts-component>`
})
export class PlanthunterAmountOfNewHuntsWrapperComponent {
	constructor() {
	}
}